import {mediaQueries} from "@khan/shared-styles";

// NOTE(jangmi): Max length of the class names. If anyone wants to change this,
// need to change in class creator package as well.
export const MAX_CLASSNAME_LENGTH = 50;

// We special case some styles used in the class-creator modal and screens for
// mobile screen sizes.
export const mobileViewCutoffQuery = mediaQueries.smOrSmaller;
